<div
	[ngClass]="{ 'height-in-opportunity-page': inOpportunitiesPage }"
	fxLayout="row"
	fxLayoutGap="1rem"
	*ngIf="v1PricingLayout"
>
	<div fxFlex>
		<mat-card *ngIf="PRODUCT_PRICING" class="h-100 padding-0-5 pricingCard" id="currentRates">
			<mat-card-title class="primary-text font-size-20" fxLayoutAlign="center center">
				Current Rates
			</mat-card-title>
			<mat-card-subtitle
				*ngIf="!priceNotFound && isCitySelectedInSearchTruckForm && !unsupportedPricingCountry"
				class="primary-text m-b-0"
			>
				<div class="p-8" fxLayoutAlign="space-between center">
					<span>
						<span>Fuel/Gal: </span>
						<span *ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader">
							<span *ngIf="lanePricing?.fuelCostPerMile; else loadingText">
								&nbsp;&nbsp;{{ lanePricing.fuelCostPerMile | currency: 'USD' : 'symbol' : '1.2-2' }}
							</span>
						</span>
					</span>

					<span>
						Trip Miles:
						<span *ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader">
							<span *ngIf="lanePricing?.laneMiles; else loadingText">
								&nbsp;&nbsp;{{ lanePricing?.laneMiles }}
							</span>
						</span>
					</span>
				</div>
			</mat-card-subtitle>

			<mat-card-content class="m-b-0 pricingCardContent">
				<div *ngIf="!priceNotFound && isCitySelectedInSearchTruckForm && !unsupportedPricingCountry; else currentRatesErrorMsg">
					<div
						class="p-8 primary-text font-size-13 p-b-0 p-r-0"
						fxLayout="row"
						fxLayoutAlign="{{
							accountSettings.CONFIDENCE_SCORE ? 'space-between start' : 'start start'
						}}"
						[ngClass]="{
							'p-t-0': !accountSettings.CONFIDENCE_SCORE,
							'p-t-0-5': accountSettings.CONFIDENCE_SCORE
						}"
					>
						<div
							class="font-size-16"
							[ngClass]="{ 'white_space_nowrap p-t-1': !accountSettings.CONFIDENCE_SCORE }"
							fxLayoutAlign="{{
								!accountSettings.CONFIDENCE_SCORE ? 'start center' : 'start start'
							}}"
						>
							<strong>All In: </strong>
						</div>
						<div
							fxLayout="column"
							fxLayoutAlign="{{
								accountSettings.CONFIDENCE_SCORE ? 'start center' : 'center center'
							}}"
							[ngClass]="{ 'full-width': !accountSettings.CONFIDENCE_SCORE }"
						>
							<div
								*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
								class="font-size-16"
								fxFlex
								fxLayoutAlign="center center"
								[ngClass]="{ 'font-size-2rem': !accountSettings.CONFIDENCE_SCORE }"
							>
								<strong *ngIf="lanePricing?.allInCost; else loadingText">{{
									lanePricing.allInCost | currency: 'USD' : 'symbol' : '1.0-0'
								}}</strong>
							</div>
							<div fxLayoutAlign="center">
								<span
									>({{ lanePricing?.allInCostLow | currency: 'USD' : 'symbol' : '1.0-0' }} -
									{{ lanePricing?.allInCostHigh | currency: 'USD' : 'symbol' : '1.0-0' }})</span
								>
							</div>
						</div>
						<div
							*ngIf="environment.CONFIDENCE_SCORE && accountSettings.CONFIDENCE_SCORE"
							class="primary-text font-size-13"
							fxLayout="row"
						>
							<div fxFlex="40"></div>
							<div
								*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
								fxFlex
								fxLayout="column"
								fxLayoutAlign="start start"
								class="font-size-13 cursor-pointer"
							>
								<div
									*ngIf="IS_NOT_NULL_OR_UNDEFINED(lanePricing?.confidenceScore); else loadingText"
								>
									<meter
										high="4"
										low="2"
										max="5"
										min="0"
										optimum="5"
										[value]="lanePricing.confidenceScore"
									></meter>
								</div>
								<p
									class="font-size-9 m-t-0"
									matTooltip="Confidence Score"
									matTooltipClass="custom-tooltip"
									fxLayout="row"
								>
									Confidence
									<mat-icon class="font-size-9 ml-2">info_outline</mat-icon>
								</p>
							</div>
						</div>
					</div>

					<div
						class="p-8 primary-text p-t-0 p-b-0"
						fxLayout="row"
						[ngClass]="{
							'm-t-1': !accountSettings.CONFIDENCE_SCORE,
							'm-t-0-5': accountSettings.CONFIDENCE_SCORE
						}"
					>
						<div class="font-size-16" fxFlex="40">
							<b>Per Mile: </b>
						</div>
						<div
							*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
							class="font-size-16 m-r-1"
							fxFlex
							fxLayoutAlign="end center"
						>
							<b *ngIf="lanePricing?.allInCost && lanePricing.laneMiles; else loadingText">
								{{
									lanePricing.allInCost / lanePricing.laneMiles
										| currency: 'USD' : 'symbol' : '1.2-2'
								}}
							</b>
						</div>
					</div>
					<div class="primary-text font-size-13 p-r-0" fxLayout="row">
						<div fxFlex="40"></div>
						<div
							*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
							fxFlex
							fxLayoutAlign="end center"
						>
							<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(lanePricing); else loadingText">
								(
								<span *ngIf="lanePricing?.allInCostLow && lanePricing?.laneMiles">
									{{
										lanePricing.allInCostLow / lanePricing.laneMiles
											| currency: 'USD' : 'symbol' : '1.2-2'
									}}
								</span>
								-
								<span *ngIf="lanePricing?.allInCostHigh && lanePricing.laneMiles">
									{{
										lanePricing.allInCostHigh / lanePricing.laneMiles
											| currency: 'USD' : 'symbol' : '1.2-2'
									}}
								</span>
								)
							</span>
						</div>
					</div>
					<br />
				</div>

				<div
					*ngIf="
						utilService.isNullOrUndefined(lanePricing) &&
						priceNotFound &&
						isCitySelectedInSearchTruckForm
					"
				>
					<div class="p-8 primary-text font-size-13 p-t-0">
						There are not enough current transactions in this system to accurately forecast this
						lane. If you run this lane regularly, contributing your transactions to the system will
						help us giving you better pricing information.
					</div>
					<div class="p-8 primary-text font-size-13">
						To find out more email
						<a class="link" href="mailto:customercare@cargochief.com">
							customercare@cargochief.com
						</a>
					</div>
				</div>
			</mat-card-content>

		</mat-card>
	</div>

	<div fxFlex>
		<mat-card
			*ngIf="productsService.RECENT_TRANSACTIONS"
			class="h-100 padding-0-5 pricingCard"
			id="recentTransactions"
		>
			<mat-card-title class="primary-text font-size-20" fxLayoutAlign="center center">
				Recent Transactions
				<mat-icon
					[inline]="true"
					[mtxPopoverTriggerFor]="recentTransactionsPopover"
					class="primary-text w-inherit pl-2"
					matSuffix
					matTooltipClass="custom-tooltip"
					mtxPopoverTriggerOn="hover"
				>
					info
				</mat-icon>
			</mat-card-title>

			<mat-card-content
				*ngIf="!isRecentTransactionsRequestInProgress; else recentTransactionsSkeleton"
				class="m-b-0 pricingCardContent"
			>
				<div *ngIf="renderRecentTransactions(); else recentTransactionsLoader">
					<div class="p-8 primary-text font-size-13 font-size-7-vw headerPadding" fxLayout="row">
						<div fxFlex fxLayoutAlign="center center">
							<b><u>Pickup Date</u></b>
						</div>
						<div fxFlex fxLayoutAlign="center center">
							<b><u>Price</u></b>
						</div>
					</div>
					<div>
						<div
							*ngFor="let transaction of recentTransactions"
							[ngClass]="{ 'font-style-italics': transaction.forThisAccount }"
							class="p-8 primary-text font-size-13 font-size-7-vw p-t-0 row-mt-3"
							fxLayout="row"
						>
							<div fxFlex fxLayoutAlign="center center">
								{{ transaction.pickupDate | date: 'MM/dd/yyyy' }}
							</div>
							<div fxFlex fxLayoutAlign="center center">
								{{ transaction.allInCost / 100 | currency: 'USD' : 'symbol' : '1.0-0' }}
							</div>
						</div>
					</div>
				</div>
			</mat-card-content>

			<mat-card-actions
				*ngIf="
					showRecentTransactionsCard &&
					IS_NOT_NULL_OR_UNDEFINED(recentTransactions) &&
					recentTransactions.length > 0
				"
				class="padding-0-5"
				fxLayoutAlign="center center"
			>
				<span
					(click)="openRecentTransactionsDialog()"
					class="primary-text font-size-13 cursor-pointer"
				>
					<u>View Details</u>
				</span>
			</mat-card-actions>
		</mat-card>
	</div>
</div>
<div fxLayout="row" *ngIf="!v1PricingLayout && PRODUCT_PRICING">
	<mat-card class="full-width">
		<mat-card-content class="m-b-0">
			<!-- Without a pricing integration -->
			<div *ngIf="!priceNotFound && isCitySelectedInSearchTruckForm && isEquipmentSelectedInSearchTruckForm && !integrationRatesEnabled">
				<div
					class="full-width"
					fxLayoutGap="1rem"
					*ngIf="showCurrentRatesCard; else currentRatesNotAvailable"
				>
					<div fxFlex fxLayoutGap="1rem">
						<div fxLayoutAlign="start center">
							<div class="full-width" fxLayoutAlign="start center">
								<div class="font-size-16 font-weight-bold" fxLayoutAlign="start center">
									Per Mile:
								</div>
								<div
									*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
									class="font-size-16 m-l-1"
								>
									<b *ngIf="lanePricing?.allInCost && lanePricing.laneMiles; else loadingText">
										{{
											lanePricing.allInCost / lanePricing.laneMiles
												| currency: 'USD' : 'symbol' : '1.2-2'
										}}
									</b>
								</div>
							</div>
						</div>
						<div fxFlex>
							<div
								class="full-width"
								fxLayout="column"
								fxLayoutAlign="space-between start"
								*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
							>
								<div fxFlex class="font-size-14 full-width" fxLayoutAlign="start start">
									Start:
									{{
										lanePricing?.allInCostLow && lanePricing.laneMiles
											? (lanePricing.allInCostLow / lanePricing.laneMiles
												| currency: 'USD' : 'symbol' : '1.0-0')
											: 'N/A'
									}}
								</div>
								<div fxFlex class="full-width" fxLayoutAlign="start center" #perMileEndContaier>
									<span class="font-size-14" #perMileEndTextContainer>
										&nbsp;End:
										{{
											lanePricing?.allInCostHigh && lanePricing.laneMiles
												? (lanePricing.allInCostHigh / lanePricing.laneMiles
													| currency: 'USD' : 'symbol' : '1.0-0')
												: 'N/A'
										}}
									</span>
								</div>
							</div>
						</div>
					</div>
					<div fxFlex>
						<div fxLayout="row" fxLayoutGap="1rem">
							<div fxFlex #allInPriceContainer>
								<div fxLayout="row" fxLayoutAlign="space-between center">
									<div fxFlex class="font-size-16 font-weight-bold" fxLayoutAlign="start center">
										All In:
									</div>
									<div
										fxFlex
										*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
										class="font-size-2rem"
										fxLayoutAlign="center center"
									>
										<strong *ngIf="lanePricing?.allInCost; else loadingText">
											{{ lanePricing.allInCost | currency: 'USD' : 'symbol' : '1.0-0' }}
										</strong>
									</div>
								</div>
							</div>
							<div fxFlex="40">
								<div class="full-width p-l-2" fxLayout="column" fxLayoutAlign="space-between start">
									<div fxFlex class="full-width" fxLayoutAlign="start start">
										<span class="font-size-14">
											Start:&nbsp;
											<span
												*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
												fxLayoutAlign="end end"
											>
												{{
													lanePricing?.allInCostLow
														? (lanePricing?.allInCostLow | currency: 'USD' : 'symbol' : '1.0-0')
														: 'N/A'
												}}
											</span>
										</span>
									</div>
									<div fxFlex class="full-width" fxLayoutAlign="start center">
										<span #allInPriceEnd class="font-size-14">
											&nbsp;End:&nbsp;
											<span
												*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
												fxLayoutAlign="end end"
											>
												{{
													lanePricing?.allInCostHigh
														? (lanePricing?.allInCostHigh | currency: 'USD' : 'symbol' : '1.0-0')
														: 'N/A'
												}}
											</span>
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div fxFlex fxLayoutAlign="end start">
						<div
							fxLayoutGap="1rem"
							fxLayoutAlign="space-between start"
							[ngStyle]="{
								'min-width': recentTransactionsLink?.nativeElement?.offsetWidth
									? 'calc(' + recentTransactionsLink.nativeElement.offsetWidth + 'px)'
									: 'inherit'
							}"
						>
							<div fxLayout="column">
								<div
									class="full-width confidence_meter_container"
									fxLayoutAlign="end start"
									*ngIf="lanePricing; else skeletonLoader"
								>
									<meter
										[style.width]="CONFIDENCE_METER_CONTAINER"
										high="4"
										low="2"
										max="5"
										min="0"
										optimum="5"
										[value]="lanePricing.confidenceScore"
									></meter>
								</div>
								<div
									class="full-width"
									fxLayoutAlign="end start"
									*ngIf="lanePricing; else skeletonLoader"
								>
									<span class="fn-size-13">Confidence:</span>
									<span>
										<mat-icon
											class="fn-size-13 confidence_meter_info_icon"
											fxLayoutAlign="center end"
											[mtxPopoverTriggerFor]="confidencePopover"
										>
											info_outline
										</mat-icon>
									</span>
								</div>
							</div>
							<div>
								<div class="full-width" fxLayout="column" fxLayoutAlign="space-between start">
									<div fxFlex class="font-size-16 full-width" fxLayoutAlign="end start">
										Min Paid:&nbsp;
										<span *ngIf="!isRecentTransactionsCountRequestInProgress; else skeletonLoader">
											{{
												recentTransactionsCount?.minAllInCost
													? (TO_DOLLARS(recentTransactionsCount.minAllInCost)
														| currency: 'USD' : 'symbol' : '1.0-0')
													: 'N/A'
											}}
										</span>
									</div>
									<div fxFlex class="font-size-16 full-width" fxLayoutAlign="end center">
										Max Paid:&nbsp;
										<span *ngIf="!isRecentTransactionsCountRequestInProgress; else skeletonLoader">
											{{
												recentTransactionsCount?.maxAllInCost
													? (TO_DOLLARS(recentTransactionsCount.maxAllInCost)
														| currency: 'USD' : 'symbol' : '1.0-0')
													: 'N/A'
											}}
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="full-width m-t-0-5" fxLayoutGap="1rem" *ngIf="showCurrentRatesCard">
					<div fxFlex fxLayoutGap="1rem" fxLayoutAlign="space-between center">
						<div fxFlex fxLayoutAlign="space-between center">
							<span>
								<span class="font-weight-bold">Fuel/Gal: </span>
								<span *ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader">
									<span *ngIf="lanePricing?.fuelCostPerMile; else loadingText">
										&nbsp;&nbsp;{{
											lanePricing.fuelCostPerMile | currency: 'USD' : 'symbol' : '1.2-2'
										}}
									</span>
								</span>
							</span>

							<span
								class="font-weight-bold"
								[ngStyle]="{
									'margin-right':
										'calc(' +
										((perMileEndContaier?.nativeElement?.offsetWidth
											? perMileEndContaier.nativeElement.offsetWidth
											: 0) -
											(perMileEndTextContainer?.nativeElement?.offsetWidth
												? perMileEndTextContainer.nativeElement.offsetWidth
												: 0)) +
										'px)'
								}"
							>
								Trip Miles:
								<span *ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader">
									<span *ngIf="lanePricing?.laneMiles; else loadingText" class="font-weight-normal">
										&nbsp;&nbsp;{{ lanePricing?.laneMiles }}
									</span>
								</span>
							</span>
						</div>
					</div>
					<div fxFlex fxLayoutGap="1rem">
						<div
							fxFlex
							fxLayoutAlign="end center"
							*ngIf="!isRecentTransactionsCountRequestInProgress; else skeletonLoader"
						>
							<span *ngIf="!recentTransactionsCount?.totalTransactions" class="fn-size-12">
								No recent matching transactions found
							</span>
							<span
								class="primary-text font-size-12 cursor-pointer text-underline"
								*ngIf="
									recentTransactionsCount?.totalTransactions &&
									recentTransactionsCount?.pastDays == 0
								"
								(click)="openRecentTransactionsDialog()"
								fxLayoutAlign="start center"
								#recentTransactionsLink
							>
								View {{ recentTransactionsCount?.totalTransactions }} Similar Transactions for the
								current day
							</span>
							<span
								class="primary-text font-size-12 cursor-pointer text-underline"
								*ngIf="
									recentTransactionsCount?.totalTransactions &&
									recentTransactionsCount?.pastDays != 0
								"
								(click)="openRecentTransactionsDialog()"
								fxLayoutAlign="start center"
								#recentTransactionsLink
							>
								View {{ recentTransactionsCount?.totalTransactions }} Similar Transactions from the
								last {{ recentTransactionsCount?.pastDays }} days
							</span>
						</div>
					</div>
				</div>
			</div>
			<!-- With a pricing integration (Triumph or Sonar) -->
			<div
				*ngIf="
					(!priceNotFound || !integrationPriceNotFound) &&
					isCitySelectedInSearchTruckForm &&
					isEquipmentSelectedInSearchTruckForm &&
					integrationRatesEnabled
				"
			>
				<div
					fxLayout="row"
					fxLayoutGap="1rem"
					*ngIf="showCurrentRatesCard || showIntegrationRateCard; else currentRatesNotAvailable"
				>
					<!-- CN-8852: Triumph prices lanes C4 cannot, so it keeps its column to the
					     right and only C4's columns are replaced. The message is scoped to C4
					     on purpose -- "Current Rates are not available" reads as though the
					     Triumph rate beside it were unavailable too. -->
					<div fxFlex class="unsupportedCountryColumn" *ngIf="unsupportedPricingCountry">
						<!-- A grid rather than a column so the link can size the space the message
						     centres in: the link occupies the first track, so the message centres
						     between the link's right edge and Triumph, not across the whole column
						     where the link's own width drags it visually left. With no link the
						     first track collapses and the message centres across everything left
						     of Triumph. The link keeps its bottom-left spot either way. -->
						<div class="unsupportedCountryMessage">
							<span class="font-size-14 text-center">
								Cargo Chief rate is not available for {{ unsupportedPricingCountry }} lanes.
							</span>
						</div>
						<span
							*ngIf="recentTransactionsCount?.totalTransactions"
							class="unsupportedCountryTransactionsLink primary-text font-size-12 cursor-pointer text-underline m-t-0-5"
							role="button"
							tabindex="0"
							(click)="openRecentTransactionsDialog()"
							(keydown.enter)="openRecentTransactionsDialog()"
							(keydown.space)="$event.preventDefault(); openRecentTransactionsDialog()"
						>
							<ng-container *ngIf="recentTransactionsCount?.pastDays == 0; else unsupportedPastDaysLink">
								View {{ recentTransactionsCount?.totalTransactions }} Similar Transactions for the
								current day
							</ng-container>
							<ng-template #unsupportedPastDaysLink>
								View {{ recentTransactionsCount?.totalTransactions }} Similar Transactions from the
								last {{ recentTransactionsCount?.pastDays }} days
							</ng-template>
						</span>
					</div>
					<div
						fxFlex
						fxLayout="column"
						fxLayoutAlign="center start"
						*ngIf="!unsupportedPricingCountry"
					>
						<div
							class="full-width"
							fxLayout="row"
							fxLayoutGap="1rem"
							[ngStyle]="{
								'min-height': allInPriceContainer?.nativeElement?.offsetWidth
									? 'calc(' + (allInPriceContainer.nativeElement.offsetHeight + 'px)')
									: 'inherit'
							}"
						>
							<div fxFlex>
								<div fxFlex fxLayoutAlign="start center" #perMileColumnContaier>
									<div class="full-width" fxLayoutAlign="start center">
										<div class="font-size-16 font-weight-bold" fxLayoutAlign="start center">
											Per Mile:
										</div>
										<div fxLayout="column" fxFlex fxLayoutAlign="center center">
											<div
												class="font-size-16 font-weight-bold"
												fxFlex
												*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
											>
												{{
													lanePricing?.allInCost && lanePricing?.laneMiles
														? (lanePricing.allInCost / lanePricing.laneMiles
															| currency: 'USD' : 'symbol' : '1.2-2')
														: 'N/A'
												}}
											</div>
											<div
												fxFlex
												class="font-size-12"
												*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
											>
												({{
													lanePricing?.allInCostLow / lanePricing?.laneMiles
														? (lanePricing.allInCostLow / lanePricing.laneMiles
															| currency: 'USD' : 'symbol' : '1.2-2')
														: 'N/A'
												}}
												-
												{{
													lanePricing?.allInCostHigh / lanePricing?.laneMiles
														? (lanePricing.allInCostHigh / lanePricing.laneMiles
															| currency: 'USD' : 'symbol' : '1.2-2')
														: 'N/A'
												}})
											</div>
										</div>
									</div>
								</div>
								<div fxFlex>
									<div
										class="full-width p-l-1"
										fxLayout="column"
										fxFlex
										fxLayoutAlign="space-between start"
									>
										<div fxFlex fxLayoutAlign="start center">
											<span class="font-weight-bold">Fuel/Gal: &nbsp;&nbsp;&nbsp;</span>
											<span
												class="font-weight-normal"
												*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
											>
												{{
													lanePricing?.fuelCostPerMile
														? (lanePricing.fuelCostPerMile | currency: 'USD' : 'symbol' : '1.2-2')
														: 'N/A'
												}}
											</span>
										</div>
										<div fxFlex fxLayoutAlign="start center" #perMileEndContaier>
											<span class="font-weight-bold">Trip Miles:&nbsp;&nbsp;</span>
											<span
												class="font-weight-normal"
												*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
											>
												{{
													lanePricing?.laneMiles
														? (lanePricing?.laneMiles | number: '1.0-0')
														: 'N/A'
												}}
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							fxLayout="row"
							fxLayoutGap="1rem"
							*ngIf="!isRecentTransactionsCountRequestInProgress; else skeletonLoader"
							class="m-t-0-5"
						>
							<div
								fxFlex
								fxLayoutAlign="start start"
								*ngIf="recentTransactionsCount?.totalTransactions"
							>
								<span
									class="primary-text font-size-12 cursor-pointer text-underline"
									*ngIf="recentTransactionsCount?.pastDays == 0"
									(click)="openRecentTransactionsDialog()"
									fxLayoutAlign="start center"
									#recentTransactionsLink
								>
									View {{ recentTransactionsCount?.totalTransactions }} Similar Transactions for the
									current day
								</span>
								<span
									class="primary-text font-size-12 cursor-pointer text-underline"
									*ngIf="recentTransactionsCount?.pastDays != 0"
									(click)="openRecentTransactionsDialog()"
									fxLayoutAlign="start center"
									#recentTransactionsLink
								>
									View {{ recentTransactionsCount?.totalTransactions }} Similar Transactions from
									the last {{ recentTransactionsCount?.pastDays }} days
								</span>
							</div>
						</div>
					</div>
					<div fxFlex *ngIf="!unsupportedPricingCountry">
						<div fxLayout="row" fxLayoutGap="1rem">
							<div fxFlex *ngIf="integrationRatesEnabled" #allInPriceContainer>
								<div fxLayout="row" fxLayoutAlign="space-between center">
									<div fxFlex class="font-size-16 font-weight-bold" fxLayoutAlign="start center">
										All In:
									</div>
									<div
										fxLayout="column"
										fxFlex
										fxLayoutAlign="center center"
										*ngIf="
											(isC4RateSetFromIntegrationData$ | async) &&
											!(isLanePricingRequestInProgress$ | async)
										"
									>
										<div
											fxFlex
											class="font-size-2rem font-weight-bold"
											*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
										>
											N/A
										</div>
									</div>
									<div
										fxLayout="column"
										fxFlex
										fxLayoutAlign="center center"
										*ngIf="!(isC4RateSetFromIntegrationData$ | async)"
									>
										<div
											fxFlex
											class="font-size-2rem font-weight-bold"
											*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
										>
											{{
												lanePricing?.allInCost
													? (lanePricing.allInCost | currency: 'USD' : 'symbol' : '1.0-0')
													: 'N/A'
											}}
										</div>
										<div
											fxFlex
											*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
										>
											({{
												lanePricing?.allInCostLow
													? (lanePricing.allInCostLow | currency: 'USD' : 'symbol' : '1.0-0')
													: 'N/A'
											}}
											-
											{{
												lanePricing?.allInCostHigh
													? (lanePricing.allInCostHigh | currency: 'USD' : 'symbol' : '1.0-0')
													: 'N/A'
											}})
										</div>
									</div>
								</div>
							</div>
							<div fxFlex="40" fxLayoutAlign="start start">
								<div fxLayout="column" class="p-l-1" #allInPriceEnd>
									<div
										class="full-width confidence_meter_container"
										fxLayoutAlign="end start"
										*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
									>
										<meter
											*ngIf="lanePricing && !(isC4RateSetFromIntegrationData$ | async)"
											[style.width]="CONFIDENCE_METER_CONTAINER"
											high="4"
											low="2"
											max="5"
											min="0"
											optimum="5"
											[value]="lanePricing.confidenceScore"
										></meter>
									</div>
									<div
										class="full-width"
										*ngIf="!(isLanePricingRequestInProgress$ | async); else skeletonLoader"
									>
										<div
											*ngIf="!(isC4RateSetFromIntegrationData$ | async)"
											fxLayoutAlign="end start"
										>
											<span class="fn-size-13" *ngIf="lanePricing">Confidence:</span>
											<span *ngIf="lanePricing">
												<mat-icon
													class="fn-size-13 confidence_meter_info_icon"
													fxLayoutAlign="center end"
													[mtxPopoverTriggerFor]="confidencePopover"
												>
													info_outline
												</mat-icon>
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Four columns share this row, all fxFlex. On an unsupported lane only two
					     survive, so an even split would centre the message at a quarter of the row
					     and leave twice as much gap on its right. Shrinking Triumph to its content
					     hands the slack to the message column instead; Triumph is already
					     end-aligned, so it stays put at the right edge either way. -->
					<div
						[fxFlex]="unsupportedPricingCountry ? 'none' : ''"
						fxLayoutAlign="end center"
						fxLayoutGap="1.5rem"
						*ngIf="greenScreensEnabled"
					>
						<div class="greenScreensLogoContainer" fxLayout="column">
							<div fxLayoutAlign="end end">
								<img
									alt="Triumph"
									class="greenScreensLogo"
									src="./assets/images/Triumph_Logo_Horiz_Pos_RGB.png"
								/>
							</div>
							<div fxLayoutAlign="end end" style="margin-top: -12px;padding-right: 12px;">Verified Buy Rate</div>
						</div>
						<div>
							<div fxLayout="column">
								<div
									*ngIf="!(isGreenScreenRequestInProgress$ | async); else skeletonLoader"
									class="font-size-2rem"
									fxLayoutAlign="end end"
								>
									<strong *ngIf="greenScreenRate?.targetBuyRate; else loadingText">
										{{ greenScreenRate.targetBuyRate | currency: 'USD' : 'symbol' : '1.0-0' }}
									</strong>
								</div>

								<div
									*ngIf="!(isGreenScreenRequestInProgress$ | async); else skeletonLoader"
									fxLayoutAlign="end end"
								>
									Start:
									{{
										greenScreenRate?.startBuyRate
											? (greenScreenRate.startBuyRate | currency: 'USD' : 'symbol' : '1.0-0')
											: 'N/A'
									}}
								</div>
							</div>
						</div>
					</div>
					<!-- Sonar takes the same column Triumph does, because an account has one
					     provider or the other. Two figures rather than Triumph's one: Sonar
					     publishes a spot and a contract rate and they answer different
					     questions, so neither can stand in for the other. Each is the median
					     with the 33rd-67th percentile band beneath it.

					     Gated on showSonarCard as well as the flag: without it a failed request
					     renders the Sonar mark over "N/A / N/A", which asserts Sonar has no rate
					     for the lane when in fact we never got an answer. -->
					<div
						[fxFlex]="unsupportedPricingCountry ? 'none' : ''"
						fxLayoutAlign="end center"
						fxLayoutGap="1.5rem"
						*ngIf="sonarEnabled && !greenScreensEnabled && showSonarCard"
					>
						<div class="sonarLogoContainer" fxLayoutAlign="end center">
							<img alt="FreightWaves SONAR" class="sonarLogo" src="./assets/images/sonar-logo.png" />
						</div>
						<div fxLayout="row" fxLayoutGap="1.5rem">
							<ng-container
								*ngTemplateOutlet="
									sonarRateColumn;
									context: { label: 'Spot Rate', rate: sonarRate?.spot }
								"
							></ng-container>
							<ng-container
								*ngTemplateOutlet="
									sonarRateColumn;
									context: { label: 'Contract Rate', rate: sonarRate?.contract }
								"
							></ng-container>
						</div>
					</div>
				</div>
			</div>
			<ng-container
				*ngIf="(priceNotFound && integrationPriceNotFound) || !isCitySelectedInSearchTruckForm || !isEquipmentSelectedInSearchTruckForm"
				[ngTemplateOutlet]="currentRatesErrorMsgV2Layout"
			></ng-container>
		</mat-card-content>
	</mat-card>
</div>

<mtx-popover #recentTransactionsPopover="mtxPopover" [closeOnPanelClick]="false">
	<mat-card class="p-0 primary-border">
		<mat-card-content class="users-dropdown font-size-14">
			<div class="padding-0-5 primary-text">
				<p>
					Recent Transactions are selected based on the search criteria and the deadhead filters you
					have set.
				</p>
				<p>Transaction in italics are transactions captured for your account.</p>
			</div>
		</mat-card-content>
	</mat-card>
</mtx-popover>

<ng-template #loadingText>
	<span>...</span>
</ng-template>

<!-- One Sonar figure: the median, with the band it sits in beneath. A lane can have one
     rate type and not the other -- spot is published for the contiguous US only -- so an
     absent rate reads as N/A here rather than removing the column and shifting the one that
     did come back. -->
<ng-template #sonarRateColumn let-label="label" let-rate="rate">
	<div fxLayout="column">
		<div class="font-size-12" fxLayoutAlign="end end">{{ label }}</div>
		<div
			*ngIf="!(isSonarRequestInProgress$ | async); else skeletonLoader"
			class="font-size-2rem"
			fxLayoutAlign="end end"
		>
			<strong>
				{{
					IS_NOT_NULL_OR_UNDEFINED(rate?.targetBuyRate)
						? (rate.targetBuyRate | currency: 'USD' : 'symbol' : '1.0-0')
						: 'N/A'
				}}
			</strong>
		</div>
		<!-- The line keeps its height with no range to show, so the sibling column's figures
		     stay on the same baselines. -->
		<div
			*ngIf="!(isSonarRequestInProgress$ | async); else skeletonLoader"
			class="sonarRateRange"
			fxLayoutAlign="end end"
		>
			<ng-container
				*ngIf="
					IS_NOT_NULL_OR_UNDEFINED(rate?.lowBuyRate) &&
					IS_NOT_NULL_OR_UNDEFINED(rate?.highBuyRate)
				"
			>
				{{ rate.lowBuyRate | currency: 'USD' : 'symbol' : '1.0-0' }} &ndash;
				{{ rate.highBuyRate | currency: 'USD' : 'symbol' : '1.0-0' }}
			</ng-container>
		</div>
	</div>
</ng-template>

<ng-template #currentRatesErrorMsg>
	<div class="recentTransactionsLoader primary-text" fxLayoutAlign="center center">
		<span *ngIf="unsupportedPricingCountry" class="p-2 text-center">
			Current Rates are not available for {{ unsupportedPricingCountry }} lanes.
		</span>
		<span *ngIf="!unsupportedPricingCountry && priceNotFound && isCitySelectedInSearchTruckForm">
			No Result found
		</span>
		<span *ngIf="!unsupportedPricingCountry && !isCitySelectedInSearchTruckForm" class="p-2 text-center">
			Current Rates are only available when the origin, destination, and equipment are provided.
		</span>
	</div>
</ng-template>

<ng-template #recentTransactionsLoader>
	<div class="recentTransactionsLoader primary-text" fxLayoutAlign="center center">
		<span *ngIf="showRecentTransactionsCard">Loading...</span>
		<span *ngIf="!showRecentTransactionsCard && isCitySelectedInSearchTruckForm">
			No Result found
		</span>
		<span
			*ngIf="!showRecentTransactionsCard && !isCitySelectedInSearchTruckForm"
			class="p-2 text-center"
		>
			Recent Transactions are only available when the origin, destination, and equipment are
			provided.
		</span>
	</div>
</ng-template>

<ng-template #recentTransactionsSkeleton>
	<div *ngIf="productsService.RECENT_TRANSACTIONS" class="h-100">
		<app-skeleton-loader [SHOW_RECENT_TRANSACTIONS]="true"></app-skeleton-loader>
	</div>
</ng-template>

<ng-template #skeletonLoader>
	<div fxFlex fxLayoutAlign="end center">
		<app-skeleton-loader
			[SHOW_SINGLE_LOADER]="true"
			class="skeletonLoaderWidth"
		></app-skeleton-loader>
	</div>
</ng-template>

<ng-template #currentRatesErrorMsgV2Layout>
	<div class="primary-text" fxLayoutAlign="center center">
		<span *ngIf="priceNotFound && isCitySelectedInSearchTruckForm && isEquipmentSelectedInSearchTruckForm"> No Result found </span>
		<span *ngIf="!isCitySelectedInSearchTruckForm" class="text-center">
			Current Rates are only available for city to city searches
		</span>
		<span *ngIf="isCitySelectedInSearchTruckForm && !isEquipmentSelectedInSearchTruckForm" class="text-center">
			Current Rates are only available when {{ inOpportunitiesPage ? 'equipment' : 'a trailer type' }} is selected
		</span>
	</div>
</ng-template>

<ng-template #currentRatesNotAvailable>
	<div class="primary-text full-width" fxLayout="column" fxLayoutAlign="center stretch">
		<ng-container *ngIf="unsupportedPricingCountry; else noResultFound">
			<!-- Pricing is unavailable for this country, but recent transactions may not be,
			     so they carry their own per-country gate: with it off the environment has no
			     transactions to offer, and both the Min/Max Paid column and the link below
			     stay out of the DOM. Where it is on, mirror the standard pricing card:
			     Min/Max Paid on the right, link bottom-right.

			     Same wording and centring as the Triumph-present state -- this is the same
			     fact, and only the presence of a second provider's rate differs. The span
			     grows while Min/Max Paid sizes to its content, so the message centres in
			     whatever space is left of it, exactly as it does beside Triumph. -->
			<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="1rem">
				<span fxFlex class="font-size-14 text-center">
					Cargo Chief rate is not available for {{ unsupportedPricingCountry }} lanes.
				</span>
				<ng-container *ngIf="areRecentTransactionsAvailableForUnsupportedCountry()">
					<div
						fxLayout="column"
						fxLayoutAlign="center end"
						*ngIf="!isRecentTransactionsCountRequestInProgress; else skeletonLoader"
					>
						<div class="font-size-16" fxLayoutAlign="end center">
							Min Paid:&nbsp;
							{{
								recentTransactionsCount?.minAllInCost != null
									? (TO_DOLLARS(recentTransactionsCount.minAllInCost)
										| currency: 'USD' : 'symbol' : '1.0-0')
									: 'N/A'
							}}
						</div>
						<div class="font-size-16" fxLayoutAlign="end center">
							Max Paid:&nbsp;
							{{
								recentTransactionsCount?.maxAllInCost != null
									? (TO_DOLLARS(recentTransactionsCount.maxAllInCost)
										| currency: 'USD' : 'symbol' : '1.0-0')
									: 'N/A'
							}}
						</div>
					</div>
				</ng-container>
			</div>
			<ng-container *ngIf="areRecentTransactionsAvailableForUnsupportedCountry()">
				<div
					class="full-width m-t-0-5"
					fxLayoutAlign="end center"
					*ngIf="!isRecentTransactionsCountRequestInProgress; else skeletonLoader"
				>
					<span *ngIf="!recentTransactionsCount?.totalTransactions" class="font-size-12">
						No recent matching transactions found
					</span>
					<span
						*ngIf="recentTransactionsCount?.totalTransactions"
						class="primary-text font-size-12 cursor-pointer text-underline"
						role="button"
						tabindex="0"
						(click)="openRecentTransactionsDialog()"
						(keydown.enter)="openRecentTransactionsDialog()"
						(keydown.space)="$event.preventDefault(); openRecentTransactionsDialog()"
					>
						<ng-container *ngIf="recentTransactionsCount?.pastDays == 0; else unsupportedCountryPastDaysLink">
							View {{ recentTransactionsCount?.totalTransactions }} Similar Transactions for the
							current day
						</ng-container>
						<ng-template #unsupportedCountryPastDaysLink>
							View {{ recentTransactionsCount?.totalTransactions }} Similar Transactions from the last
							{{ recentTransactionsCount?.pastDays }} days
						</ng-template>
					</span>
				</div>
			</ng-container>
		</ng-container>
		<ng-template #noResultFound>
			<div fxLayout="row" fxLayoutAlign="center center">No Result found</div>
		</ng-template>
	</div>
</ng-template>

<mtx-popover #confidencePopover="mtxPopover" [closeOnPanelClick]="false">
	<mat-card class="p-0 primary-border">
		<mat-card-content class="confidence_popover_container font-size-14">
			<div class="padding-0-5 primary-text">
				<p class="text_align_justify">
					C4 pricing is generated by a set of predictive models calculated on millions of rows of
					transaction data. Those models are then applied to your data, as well as, matching recent
					transactions, and the search criteria enetered to produce a predicted market rate.
				</p>
				<p class="text_align_justify">
					The confidence score measures how confident the pricing system is in its prediction.
					Confidence is based on which pricing model is used, how many recent transactions are
					available, and how much historical data you have for the lane.
				</p>
			</div>
		</mat-card-content>
	</mat-card>
</mtx-popover>
